import { render, staticRenderFns } from "./OpenTableName.vue?vue&type=template&id=5d889bba&scoped=true"
import script from "./OpenTableName.vue?vue&type=script&lang=js"
export * from "./OpenTableName.vue?vue&type=script&lang=js"
import style0 from "./OpenTableName.vue?vue&type=style&index=0&id=5d889bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d889bba",
  null
  
)

export default component.exports